/**
 * tk-fbt-add — bezformové „Do košíku" pro FBT dlaždice v košíku.
 *
 * PROČ: FBT karty jsou uvnitř `<form id="cart-form">` (obaluje tabulku položek).
 * Standardní add-to-cart přes `<product-form-component>` + `{% form 'product' %}`
 * by byl VNOŘENÝ form → HTML to zakazuje, prohlížeč vnitřní form zahodí a přidání
 * nefunguje. Proto přidáváme přímo přes /cart/add.js a vyvoláme stejný cart-update
 * (CartAddEvent → sekce se zmorfují, badge/drawer se aktualizují) jako běžný add.
 *
 * Markup: <button data-tk-fbt-add data-variant-id="…" data-product-id="…">…</button>
 */
import { CartAddEvent } from '@theme/events';

const ADD_URL = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

document.addEventListener('click', (event) => {
  const btn = event.target.closest('[data-tk-fbt-add]');
  if (!btn) return;
  event.preventDefault();
  if (btn.dataset.loading) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.dataset.loading = '1';
  btn.classList.add('is-loading');

  const sections = Array.from(document.querySelectorAll('cart-items-component'))
    .map((c) => c.dataset.sectionId)
    .filter(Boolean)
    .join(',');

  // Optimistický bump badge (stejný event jako product-form)
  btn.dispatchEvent(new CustomEvent('cart:add:initiate', { bubbles: true, composed: true, detail: { quantity: 1 } }));

  fetch(ADD_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1, sections }),
  })
    .then((r) => r.json())
    .then((res) => {
      if (res.status) {
        // chyba (např. vyprodáno) — vrátit optimistický bump
        btn.dispatchEvent(new CustomEvent('cart:add:revert', { bubbles: true, composed: true, detail: { quantity: 1 } }));
        return;
      }
      // vizuální „Přidáno" feedback
      btn.classList.add('tk-fbt-add--done');
      setTimeout(() => btn.classList.remove('tk-fbt-add--done'), 1600);
      // morph cart sekcí + aktualizace badge/draweru
      btn.dispatchEvent(
        new CartAddEvent({}, String(variantId), {
          source: 'tk-fbt-add',
          itemCount: 1,
          productId: btn.dataset.productId,
          sections: res.sections,
        })
      );
    })
    .catch(() => {})
    .finally(() => {
      delete btn.dataset.loading;
      btn.classList.remove('is-loading');
    });
});
